import PropTypes from 'prop-types';
import portalContainerPropType from '../shared/portal/container_prop_type';
import deprecatedProp from '../utils/deprecated_prop';
import { popoverPlacements } from '../shared/popover/prop_types';
var tablePositionPropTypes = {
  bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var behaviorPropTypes = {
  type: PropTypes.oneOf(['singlePage']),
  offset: PropTypes.shape(tablePositionPropTypes)
};
var columnsPropTypes = {
  filter: PropTypes.element,
  id: PropTypes.string.isRequired,
  index: PropTypes.oneOf(['visible', 'hidden', 'none']),
  label: PropTypes.string.isRequired,
  sortable: PropTypes.bool
};
var paginationPropTypes = {
  currentPage: PropTypes.number,
  i18n: PropTypes.shape({
    currentPage: PropTypes.string.isRequired,
    goto: PropTypes.string.isRequired,
    next: PropTypes.string.isRequired,
    paginationNavigation: PropTypes.string.isRequired,
    previous: PropTypes.string.isRequired
  }),
  onPageChange: PropTypes.func,
  pageSize: PropTypes.number,
  paginationNavigationSize: PropTypes.number,
  popoverPlacement: PropTypes.oneOf(popoverPlacements),
  totalItems: PropTypes.number.isRequired
};
var sortTypes = ['ascending', 'descending'];
var sortByPropTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(sortTypes).isRequired
};
var widthPropTypes = {
  columnId: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  width: PropTypes.number
};
var preferencesPropTypes = {
  defaultOrder: PropTypes.arrayOf(PropTypes.string.isRequired),
  disableResetToDefault: PropTypes.bool,
  headerNoWrap: PropTypes.bool,
  onResetToDefault: PropTypes.func,
  order: PropTypes.arrayOf(PropTypes.string.isRequired),
  showResizeTooltip: PropTypes.bool,
  sortBy: PropTypes.shape(sortByPropTypes),
  width: PropTypes.arrayOf(PropTypes.shape(widthPropTypes).isRequired)
};
var propTypes = {
  actionArea: PropTypes.node,
  behavior: PropTypes.shape(behaviorPropTypes),
  className: PropTypes.string,
  columnReorderFooterAlign: PropTypes.oneOf(['center', 'end', 'start']),
  columnReorderInfiniteScroll: PropTypes.bool,
  columnReorder: PropTypes.bool,
  columnReorderPortalContainer: portalContainerPropType,
  columnResize: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.shape(columnsPropTypes).isRequired).isRequired,
  component: PropTypes.elementType,
  controlArea: PropTypes.node,
  customNoItems: PropTypes.node,
  // @ts-expect-error good enough for now :)
  data: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  i18n: PropTypes.shape({
    actionButton: PropTypes.string.isRequired,
    cancelButton: PropTypes.string.isRequired,
    clearAllFilters: PropTypes.string.isRequired,
    columnOptions: PropTypes.string.isRequired,
    columnResizeTooltip: PropTypes.string.isRequired,
    deselectAllItems: PropTypes.string.isRequired,
    downButton: PropTypes.string.isRequired,
    itemSelected: PropTypes.string.isRequired,
    itemsSelected: PropTypes.string.isRequired,
    noItems: PropTypes.string.isRequired,
    resetToDefault: PropTypes.string.isRequired,
    saveButton: PropTypes.string.isRequired,
    selectAllItems: PropTypes.string.isRequired,
    selectAllPageItems: PropTypes.string.isRequired,
    sortedAscending: PropTypes.string.isRequired,
    sortedDescending: PropTypes.string.isRequired,
    upButton: PropTypes.string.isRequired
  }),
  loading: PropTypes.bool,
  loadingDataLength: PropTypes.number,
  numberOfSelectedItems: PropTypes.number,
  onClearAllFilters: PropTypes.func,
  onColumnReorder: PropTypes.func,
  onDeselectAllItems: PropTypes.func,
  onResizeColumn: PropTypes.func,
  onSelect: PropTypes.func,
  onSelectAll: deprecatedProp(PropTypes.func, 'The `onSelectAll` callback is being deprecated, please use `onSelectAllPageItems` callback instead'),
  onSelectAllItems: PropTypes.func,
  onSelectAllPageItems: PropTypes.func,
  onSort: PropTypes.func,
  pagination: PropTypes.shape(paginationPropTypes),
  preferences: PropTypes.shape(preferencesPropTypes),
  rerenderColumnsOnLoad: PropTypes.bool,
  rowSelectAllState: PropTypes.oneOf(['all', 'indeterminated', 'none']),
  rowSelector: PropTypes.oneOf(['avatar', 'multiSelection']),
  showClearAllFilters: PropTypes.bool,
  showFilters: PropTypes.bool
};
export default propTypes;